import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getImageSources } from 'src/containers/AddSkuPageV2/utils';
import { Picture } from 'src/components/Elements/Picture';
import { MOBILE_AND_TABLET, DESKTOP } from 'src/containers/AddSkuPageV2/constants';
import styles from '../styles.scss';

const AddSkuV2SkuImage = ({ type = DESKTOP, className, sku, withBorderRadius }) => {
  const imageSources = getImageSources({ type, sku });
  const isProductSku = sku && sku.get('gallery');
  const imageContainerStyles = cn(styles.skuImageContainer, className, {
    [styles.showMobileTabletOnly]: type === MOBILE_AND_TABLET,
    [styles.showDesktopOnly]: type === DESKTOP,
  });
  const imageStyles = cn(styles.skuImage, {
    [styles.withBorderRadius]: withBorderRadius,
    [styles.contain]: isProductSku,
  });
  return (
    <div className={imageContainerStyles}>
      <Picture sources={imageSources} className={imageStyles} />
    </div>
  );
};

AddSkuV2SkuImage.propTypes = {
  type: PropTypes.oneOf([MOBILE_AND_TABLET, DESKTOP]),
  className: PropTypes.string,
  sku: PropTypes.object.isRequired,
  withBorderRadius: PropTypes.bool,
};

export default AddSkuV2SkuImage;
